define([
    "csi/action/FreezeBase",
    "csi/def/ActionFactory",
    "csi/util",
    "csi/xml"
], function(FreezeBase,ActionFactory,util,xml) {

    return ActionFactory.declare("Freeze", FreezeBase, {
        constructor: function(obj) {
            this.m_tag = this.m_tag || "Freeze";
            this.m_bFreezeOnly = util.getProperty(obj,"FreezeOnly","0") == "1";
        },

        checkNodeAccess: function(node) {
            if (!this.inherited(arguments))
                return false;

            // if the action should be shown for 'Freeze' only and the node is already frozen, do not show this action.
            if (this.m_bFreezeOnly && xml.nodeIsFrozen(node)) {
                return false;
            }

            return true;
        },

        isToggledInitially: function(/*csi.def.Context*/ctx) {
            // summary: determine if action should be in toggled state initially
            return !!xml.nodeIsFrozen(ctx.getNode());
        }
    });
});